/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Коллекция для поселений
   */
  app.Settlements = app.Collection.extend({
    model: app.Settlement,
    urlRoot: app.entryScriptName + '/api/v3/settlement',

    run: function (data, options) {
      if (options && options.user) {
        this.user = options.user;
      }
      this.expand = 'expand=has_active_jp_purchase';
    },
  });
})();

}.call(window));